import { CostProfile, Id, Identifiable, Resource } from "@planzone/dto";
import { Linker } from "../linkers/types";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = Identifiable<Resource> & {
  costProfile: Identifiable<CostProfile> | null;
};

type WeeklyCalendarResponse = {
  uuid: Id;
  fridayHours: number;
  mondayHours: number;
  saturdayHours: number;
  sundayHours: number;
  thursdayHours: number;
  tuesdayHours: number;
  wednesdayHours: number;
};

function getWeeklyCalendar(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<WeeklyCalendarResponse>({
        endpoint: `/resources/${resource.uuid}/weeklyCalendar`,
        method: HttpMethods.GET,
      })
      .then((response) => ({
        uuid: response.uuid,
        friday: { capacity: response.fridayHours },
        monday: { capacity: response.mondayHours },
        saturday: { capacity: response.saturdayHours },
        sunday: { capacity: response.sundayHours },
        thursday: { capacity: response.thursdayHours },
        tuesday: { capacity: response.tuesdayHours },
        wednesday: { capacity: response.wednesdayHours },
      }));
}

function getResource(httpClient: HttpClient, linker: Linker) {
  return (resourceId: Id) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/resources/${resourceId}?projection=sheet&embed_links=false`,
        method: HttpMethods.GET,
      })
      .then((resource) => ({
        ...resource,
        tags: resource.tags.map((tag) => {
          // @ts-ignore
          return typeof tag === "string" ? { name: tag } : tag;
        }),
      }))
      .then((resource) =>
        getWeeklyCalendar(httpClient)(resource).then((weeklyCalendar) => ({
          ...resource,
          weeklyCalendar,
        })),
      )
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { getResource };
